import { Injectable, Signal, signal, WritableSignal } from "@angular/core";
import { ColorTheme } from "../../pages/kartlegging/types/ColorTheme";

const DEFAULT_COLOR_THEME = ColorTheme.DEFAULT;

/**
 * Manage category-specific colorTheme
 */
@Injectable({ providedIn: "root" })
export class ColorThemeService {
  private _colorTheme: WritableSignal<ColorTheme> = signal(DEFAULT_COLOR_THEME);
  public colorTheme: Signal<ColorTheme> = this._colorTheme.asReadonly();

  public setTheme(theme: ColorTheme): void {
    this._colorTheme.set(theme);
  }

  public resetTheme(): void {
    this._colorTheme.set(DEFAULT_COLOR_THEME);
  }
}
